import React, {useState} from "react";
import {Typography} from "@mui/material";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import ETLGoogleConfigurationTableApplet from "../eoec/applet/impl/ETLGoogleConfiguration/ETLGoogleConfigurationTableApplet";
import ETLGoogleConfigurationDetailTableViewApplet from "../eoec/applet/impl/ETLGoogleConfiguration/ETLGoogleConfigurationDetailTableViewApplet";


export default function Google() {
    const [etlGoogleConfigurationEnterpriseObject] = useState(enterpriseObjectClassFactory("ETLGoogleConfiguration") as EnterpriseObject);

    function renderGoogleConfigurations() {

        return (
            <>
                <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
                   <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                        <ETLGoogleConfigurationTableApplet enterpriseComponent={etlGoogleConfigurationEnterpriseObject?.getEnterpriseComponent("ETLGoogleConfiguration")}/>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
                   <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                        <ETLGoogleConfigurationDetailTableViewApplet enterpriseComponent={etlGoogleConfigurationEnterpriseObject?.getEnterpriseComponent("ETLGoogleConfigurationDetail")}/>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Google Drive Configurations</Typography>
                </div>
            </div>
            {renderGoogleConfigurations()}
        </div>
    );
}